import { Stack } from "@mui/material";
import ECommerceOffers from "./ECommerceOffers";

const ECommerceOffersPage = () => {
  return (
    <Stack
      spacing={1}
      sx={{
        marginTop: "1.5em",
      }}
    >
      <ECommerceOffers />
    </Stack>
  );
};

export default ECommerceOffersPage;
